import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './BasketSkeleton.module.scss';

export const BasketSkeleton = () => {
    return (
        <div className={styles.skeletonContainer}>
            <div style={{ flex: 1 }}>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={30}
                    backgroundColor="#f5f5f5"
                    foregroundColor="#dbdbdb"
                >
                    <rect x="0" y="0" rx="4" ry="4" width="100%" height="100" />
                </ContentLoader>
            </div>

            <div>
                <ContentLoader
                    speed={2}
                    width="100%"
                    height={630}
                    backgroundColor="#f5f5f5"
                    foregroundColor="#dbdbdb"
                >
                    <rect x="0" y="0" rx="4" ry="4" width="100%" height="630" />
                </ContentLoader>
            </div>
        </div>
    );
};
